import React, { type FC } from 'react'
import { RequiredFieldHelperText, skeletonStyles, ChamberSelect, UsStateSelect } from 'components'
import { FormControl, Skeleton, Stack, TextField } from '@mui/material'
import { type LeadershipOfficerCreationInfo } from 'helpers'
import { LeadershipOfficerTypeSelect } from 'components/us/leadership/leadership-officer-type-select'

interface LeadershipOfficerBasicInfoFieldsProps {
  loading: boolean
  disabled: boolean
  officer: LeadershipOfficerCreationInfo
  updateValue: (
    updater: (prevState: any) => any
  ) => void
  isFieldEmpty: (key: string) => boolean
  errorFields: string[]
}

export const LeadershipOfficerBasicInfoFields: FC<LeadershipOfficerBasicInfoFieldsProps> = ({
  loading,
  disabled,
  officer,
  updateValue,
  errorFields,
  isFieldEmpty
}) => {
  console.log('LeadershipOfficerBasicInfoFields rendering with officer:', officer)

  const updateField = (field: string, newValue: any): void => {
    console.log(`Updating field ${field} with value:`, newValue)
    updateValue((prevState) => {
      return { ...prevState, [field]: newValue }
    })
  }

  const isError = (field: string): boolean => {
    return errorFields.includes(field)
  }

  return (
    <Stack spacing={1}>
      {loading
        ? (
          <>
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} variant="rectangular" sx={skeletonStyles} />
            ))}
          </>
          )
        : (
          <>
            <TextField
              id="ofcname"
              disabled={disabled}
              label="Officer Name"
              variant="outlined"
              value={officer.ofcname}
              error={isError('ofcname')}
              onChange={(e: any) => { updateField('ofcname', e.target.value) }}
              fullWidth />
            <RequiredFieldHelperText isEmpty={isFieldEmpty('ofcname')}>
              Officer Name field is required
            </RequiredFieldHelperText>

            <FormControl variant="outlined" fullWidth={true} error={isError('legchamber')}>
              <ChamberSelect
                value={officer.legchamber}
                updateChamber={(c) => { updateField('legchamber', c) }}
                disabled={disabled}
              />
            </FormControl>
            <RequiredFieldHelperText isEmpty={isFieldEmpty('legchamber')}>
              Chamber field is required
            </RequiredFieldHelperText>

            <FormControl variant="outlined" fullWidth={true} error={isError('role')}>
              <LeadershipOfficerTypeSelect
                value={officer.role}
                updateLeadershipOfficerType={(r) => { updateField('role', r) }}
                disabled={disabled}
              />
            </FormControl>
            <RequiredFieldHelperText isEmpty={isFieldEmpty('role')}>
              Role field is required
            </RequiredFieldHelperText>

            <FormControl variant="outlined" fullWidth={true} error={isError('state')}>
              <UsStateSelect
                value={officer.state}
                updateState={(state) => { updateField('state', state) }}
                disabled={disabled}
              />
            </FormControl>
            <RequiredFieldHelperText isEmpty={isFieldEmpty('state')}>
              State field is required
            </RequiredFieldHelperText>
          </>
          )}
    </Stack>
  )
}
